import { render, staticRenderFns } from "./specialTestDetail.vue?vue&type=template&id=3d1ce58c"
import script from "./specialTestDetail.vue?vue&type=script&lang=js"
export * from "./specialTestDetail.vue?vue&type=script&lang=js"
import style0 from "./specialTestDetail.vue?vue&type=style&index=0&id=3d1ce58c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports